/**
 * User Account API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareDto } from './shareDto';
import { RequestedShare } from './requestedShare';


export interface ShareableDto { 
    id?: number;
    label?: string;
    role?: ShareableDto.RoleEnum;
    shares?: Array<ShareDto>;
    requestedShares?: Array<RequestedShare>;
    name: string;
    description?: string;
}
export namespace ShareableDto {
    export const RoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


